module.exports = __webpack_public_path__ + "img/uid-success-bg.1f9f677.png";